/**
 * Platform detection — the single seam between the web/PWA build and the
 * Capacitor native build.
 *
 * `@capacitor/core` is an optional dependency: on a plain web build it may not
 * be installed, so we resolve it defensively and fall back to "web" rather than
 * throwing. This lets the same source compile and run identically on the web
 * (where it always reports web) and inside the native WebView.
 *
 * Use `isNative` to guard anything that must differ on device: the router type,
 * the API base URL, service-worker registration, status-bar/keyboard wiring,
 * native plugins, etc. Web behavior must stay byte-for-byte unchanged.
 */
let _isNative = false;
let _platform = 'web';

try {
  // eslint-disable-next-line global-require, import/no-unresolved
  const { Capacitor } = require('@capacitor/core');
  if (Capacitor && typeof Capacitor.isNativePlatform === 'function') {
    _isNative = Capacitor.isNativePlatform();
    _platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
  }
} catch {
  // @capacitor/core not installed (pure web build) → stay web.
}

export const isNative = _isNative;
export const isWeb = !_isNative;
export const platform = _platform; // 'ios' | 'android' | 'web'
export const isIOS = _platform === 'ios';
export const isAndroid = _platform === 'android';
